import { STEP_MAP } from "@/constants/common.constants";

export const findStepWithSectionTitle = (sectionTitle) => {
  return STEP_MAP.find((s) => s.sectionTitle === sectionTitle);
};

/**
 * find section by title in the section provided, handling cases where new quote journey's step
 * not in the same order in STEP_MAP
 * @param {Array<{sectionTitle: string}>} section array of section provided
 * @param {string} sectionTitle section of title to find
 * @returns
 */
export const findSectionByTitle = (sections, sectionTitle) => {
  return sections.find((x) => x.SectionTitle === sectionTitle);
};
